webpackJsonp([59330042967093],{

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hero-about.e42aba3a.jpeg";

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.queryAboutPage = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(41);
	
	var _sections = __webpack_require__(25);
	
	var _components = __webpack_require__(78);
	
	var _heroAbout = __webpack_require__(466);
	
	var _heroAbout2 = _interopRequireDefault(_heroAbout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageAbout = function (_Component) {
	  _inherits(PageAbout, _Component);
	
	  function PageAbout(props) {
	    _classCallCheck(this, PageAbout);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      scrollDiv: 'about-us'
	    };
	    return _this;
	  }
	
	  PageAbout.prototype.render = function render() {
	    var scrollDiv = this.state.scrollDiv;
	    var data = this.props.data;
	
	    var wp = (0, _helpers.getPageData)(data, 'About');
	    return _react2.default.createElement(
	      _sections.PageWrapper,
	      { page: 'about' },
	      _react2.default.createElement(_sections.Hero, {
	        page: 'about',
	        data: _extends({}, wp, {
	          hero_background: {
	            localFile: {
	              childImageSharp: {
	                sizes: {
	                  originalImg: _heroAbout2.default
	                }
	              }
	            }
	          }
	        }),
	        scrollTo: scrollDiv
	      }),
	      _react2.default.createElement(
	        'section',
	        { className: 'about-us', id: 'about-us' },
	        _react2.default.createElement(
	          'div',
	          { className: 'about-us__text-top' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title' },
	            'What makes us different.'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'text text--lg' },
	            'No job or project is too big or too small. We offer a professional team of operatives that have CSCS, IPAF, City & Guilds and First Aid qualifications.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'about-us__content' },
	          _react2.default.createElement(
	            'p',
	            { className: 'text' },
	            'In the past, we only offered window and gutter cleaning services which were carried out in the traditional way (ladder, bucket, squeegee and blade). As Health & Safety tightened and technology moved on we introduced the Pure Water Reach & Wash System (Hot & Cold). This system enables you to carry out your duties with your feet firmly on the ground!'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'text' },
	            'Reach & Wash opened many different opportunities in the commercial/domestic fields. Using this system we can now reach windows and different areas we could never get to working from a ladder or temporary platforms. As time went on we started cleaning schools, offices, blocks of apartments, hospitals etc.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'why-us' },
	        _react2.default.createElement(
	          'div',
	          { className: 'why-us__row' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'why-us__reasons' },
	            _react2.default.createElement(
	              'li',
	              { className: 'why-us__item' },
	              _react2.default.createElement(
	                'h3',
	                { className: 'title title--sm title--white' },
	                'Flexible booking'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'text text--white' },
	                'We always accommodate for our clients, that why we offer flexible booking to your availability.'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'why-us__item' },
	              _react2.default.createElement(
	                'h3',
	                { className: 'title title--sm title--white' },
	                'Purified water'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'text text--white' },
	                'Mechanically filtered to remove impurities, eliminating the streaks on glass that are often associated with the use of unfiltered water and detergents, as well as environmental benefits.'
	              )
	            )
	          ),
	          _react2.default.createElement(_components.Testimonials, { list: wp.testimonials })
	        )
	      )
	    );
	  };
	
	  return PageAbout;
	}(_react.Component);
	
	exports.default = PageAbout;
	var queryAboutPage = exports.queryAboutPage = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-page-about-js-7250972aec56aab6a8cb.js